import Container_BubbleAreaLeftComponent from '../components/Container/viewer/skinComps/BubbleAreaLeft/BubbleAreaLeft.skin';


const Container_BubbleAreaLeft = {
  component: Container_BubbleAreaLeftComponent
};


export const components = {
  ['Container_BubbleAreaLeft']: Container_BubbleAreaLeft
};

